import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { DateRange } from "@enums/DateRange.enum";
import { SortDirection } from "@enums/SortDirection";
import { IDriver } from "@interfaces/IDriver";
import { IJourney } from "@interfaces/IJourney";
import { IPlotEvent } from "@interfaces/IPlot";
import { IVehicle } from "@interfaces/IVehicle";
import { IDateFilter } from "@interfaces/filters/IDateFilter";
import { DriverService } from "@services/driver.service";
import { JourneyService } from "@services/journey.service";
import { TranslationService } from "@services/translation.service";
import { VeriDate } from "@services/veriDate.service";
import * as angular from "angular";
import { CameraService } from "../services/camera.service";
import "./videoJourneySummary.scss";

class VideoJourneySummaryComponentController implements angular.IComponentController {

    journeys: IJourney[] = [];
    selectedJourney: IJourney;

    veriMap: IVeriMapComponent;
    veriTableMap: IVeriMapComponent;

    vehicle: IVehicle;
    drivers: IDriver[] = [];

    selectedEvent: IPlotEvent;
    highlightedEvent: IPlotEvent;

    dateFilter: IDateFilter;
    defaultDateRange: DateRange = DateRange.Today;

    loading: boolean = false;

    onVideoEventClick?: (args: { requestVideoTime: Date }) => void;

    static $inject = ['$q', 'journeyService', 'driverService', 'veriDate', "cameraService", "translationService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly journeyService: JourneyService,
        private readonly driverService: DriverService,
        private readonly veriDate: VeriDate,
        private readonly cameraService: CameraService,
        private readonly translationService: TranslationService
    ) {
    }

    $onInit(): void {}

    $onChanges(): void {
        this.getJourneyData();
    }

    onColumnClose() {
        setTimeout(() => { this.selectedJourney = null; }, 350);
    }

    onVeriMapLoaded(veriMap: IVeriMapComponent) {
        this.veriMap = veriMap;
    }

    onVeriMapTableLoaded(veriMap: IVeriMapComponent) {
        this.veriTableMap = veriMap;
    }

    eventClicked(journey: IJourney, event: IPlotEvent) {
        if (event.video && this.onVideoEventClick) {
            this.onVideoEventClick({ requestVideoTime: new Date(event.Utc) });
            return;
        }
        if (event.showMore) {
            journey["displayEvents"] = journey.events;
        }
        else {
            this.setSelectedEvent(event);
        }
    }

    setSelectedEvent(event: IPlotEvent) {
        if (this.selectedEvent == event || !event) {
            this.selectedEvent = null;
            this.highlightedEvent = null;
        }
        else {
            this.selectedEvent = event;
            this.highlightedEvent = event;
        }
    }

    dateFilterChanged(filter: IDateFilter) {
        if (angular.equals(filter, this.dateFilter)) {
            return;
        }

        this.dateFilter = filter;
        this.getJourneyData();
    }

    setSelectedJourney(journey: IJourney) {
        this.selectedEvent = null;

        if (this.selectedJourney == journey || !journey) {
            this.selectedJourney = null;
            return;
        }

        this.selectedJourney = journey;
    }

    // ---

    private getJourneyData(invalidateCache: boolean = false) {
        this.loading = true;
        const promises = [];

        let dateToFilter: Date = (this.dateFilter?.start || new Date);

        const journeyPromise = this.journeyService.getAllJourneyDataForVehicle(this.vehicle, dateToFilter, true);
        const driverPromise = this.driverService.getDrivers({ invalidateCache });

        promises.push(journeyPromise, driverPromise);

        this.$q.all(promises)
            .then(([historicalDay, drivers]) => {
                this.journeys = historicalDay.journeyModel.journeys;
                this.drivers = drivers;

                this.setJourneyDriver();
                this.sortJourneys();

                this.journeys.forEach(j => {
                    j.events.sort((a, b) => {
                        return this.veriDate.sort(a.Utc, b.Utc, SortDirection.Ascending);
                    });

                    j.events = this.cameraService.getFilteredEventsForVideo(j.events);

                    var displayEvents = j.events;
                    var displayEventsCollapsed = false;

                    if (displayEvents.length > 3) {
                        var expandEvent: IPlotEvent = {
                            id: "expander",
                            showMore: true,
                            label: this.translationService.t('videoJourneySummary.showMoreEvents', j.events.length - 2),
                            icon: "warning"
                        };

                        displayEvents = [displayEvents[0], expandEvent, displayEvents[displayEvents.length - 1]];

                        displayEventsCollapsed = true;
                    }

                    j["displayEventsCollapsed"] = displayEventsCollapsed;
                    j["displayEvents"] = displayEvents;
                });
            })
            .catch(err => console.log('error', err))
            .finally(() => {
                this.loading = false;
            })
    }

    private setJourneyDriver() {
        if (this.journeys) {
            this.journeys.forEach(journey => {
                journey.driver = this.drivers.find(d => d.Id === journey.DriverId);
            })
        }
    }

    private sortJourneys() {

        this.journeys.sort((a, b) => {
            return this.veriDate.sort(a.StartUtc, b.StartUtc, SortDirection.Descending);
        });

        this.journeyService.processJourneys(this.journeys);

        this.journeys.forEach(j => {
            if (!j.LinePoints) {
                return;
            }
        });
    }
}

export class VideoJourneySummaryComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            vehicle: "<",
            onVideoEventClick: "&"
        };

        this.controller = VideoJourneySummaryComponentController;
        this.template = require("./videoJourneySummary.html");
    }
}
